import { noop } from "lodash";

export function delay(ms: number) {
  return new Promise<void>((resolve) => {
    setTimeout(resolve, ms);
  });
}

export function never<T = void>() {
  return new Promise<T>(noop);
}
